<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
      <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
    </a-space>
    <a-divider style="margin-top: 2px">{{$t('divider.configurationList')}}</a-divider>
    <maintenance-config-table ref="table" @click="onTableClick" />
    <a-divider style="margin-top: 2px">{{$t('divider.configurationDetails')}}</a-divider>
    <maintenance-config-detail ref="detail" @saveSuccess="refresh" />
  </a-layout>
</template>
<script>
import MaintenanceConfigTable from '@/views/quality/maintenance/config/MaintenanceConfigTable.vue'
import MaintenanceConfigDetail from '@/views/quality/maintenance/config/MaintenanceConfigDetail.vue'

export default {
  name: 'MaintenanceConfig',
  components: { MaintenanceConfigDetail, MaintenanceConfigTable },
  data() {
    return {
      saveDisable: true,
      addDisable: false,
      refreshDisable: false,
    }
  },
  methods: {
    onTableClick(record) {
      this.$refs.detail.fetch(record)
    },
    add() {
      this.$refs.detail.clear()
    },
    save() {
      this.$refs.detail.save()
    },
    refresh() {
      this.$refs.table.getData()
      this.$refs.detail.clear()
    }
  }
}
</script>